"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ReportBuildResource = /** @class */ (function (_super) {
    tslib_1.__extends(ReportBuildResource, _super);
    function ReportBuildResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportBuildResource.endpoint = '/reports/builds';
    ReportBuildResource.MODEL_NAME = 'reportcacheddata';
    return ReportBuildResource;
}(base_1.default));
exports.default = ReportBuildResource;
//# sourceMappingURL=reportbuild.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/reports/reportbuild.js
// module id = 79+J
// module chunks = 0